import { createFileRoute, Navigate, useMatchRoute } from "@tanstack/react-router";

const Component = () => {
  const matchRoute = useMatchRoute();
  const match = matchRoute({
    to: "/consent-solutions/$csId",
    fuzzy: true,
  });

  if (match === false) {
    throw new Error("Consent solution ID is not set");
  }

  return <Navigate to="/consent-solutions/$csId/domains" params={{ csId: match.csId }} />;
};

const Route = createFileRoute("/_authorized/consent-solutions/$csId/")({
  component: () => <Component />,
});

export { Route };
